import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { StoryboardPageProps, StoryboardEntryProps } from "./StoryboardPage";
const StoryboardPage = lazy(() => import("./StoryboardPage").then(module => ({ default: module.StoryboardPage })));
const StoryboardEntry = lazy(() => import("./StoryboardPage").then(module => ({ default: module.StoryboardEntry })));
export function mountStoryboardPage(slot: HTMLElement, p: StoryboardPageProps) {
  setStudioView("stage", "storyboard-page:" + p.projectId, <StoryboardPage {...p} />);
}
export function mountStoryboardEntry(
  slot: HTMLElement,
  p: StoryboardEntryProps,
) {
  setStudioView("stage", "storyboard-entry:" + p.projectId, <StoryboardEntry {...p} />);
}
